import styled from 'styled-components';

export const OrderPaymentContainer = styled.div``;

export const CreditCardContainer = styled.div<{
  isSelected: boolean;
  isCreditCardAuthorizationFailure?: boolean;
}>`
  padding: 5px 15px;
  border-radius: 5px;
  border: 2px solid rgba(32, 154, 214, 1);
  margin-top: 10px;
  display: flex;
  align-items: center;
  box-shadow: ${({ isSelected }) =>
    isSelected ? '0px 4px 12px rgba(0, 0, 0, 0.08)' : 'none'};
  border: ${({ isSelected, isCreditCardAuthorizationFailure }) => {
    if (!isSelected) {
      return '1px solid rgba(0, 0, 0, 0.23)';
    }
    if (isCreditCardAuthorizationFailure) {
      return '2px solid rgba(212, 63, 88, 1)';
    }
    return '2px solid rgba(32, 154, 214, 1)';
  }};
  cursor: pointer;
`;

export const CreditCard = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  ${({ theme }) => theme.breakpoints.down('lg')} {
    width: 75%;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 85%;
  }
`;

export const EPTMessageContainer = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.63);
  padding: 0px 0px 5px 0px;
`;

export const CreditCardErrorMessage = styled.div`
  font-weight: 400;
  color: rgba(212, 63, 88, 1);
  size: 0.9rem;
  margin-left: 30px;
`;

export const Expiry = styled.div`
  min-width: 20%;
  max-width: 20%;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.63);
  size: 0.9rem;
  margin-left: 20px;
`;

export const CreditCardReadOnly = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  ${Expiry} {
    margin-left: 10px;
  }
`;

export const AddPaymentMethod = styled.a`
  font-weight: 400;
  color: rgba(32, 154, 214, 1);
  font-size: 0.8rem;
`;

export const DefaultCard = styled.span`
  font-weight: 400;
  background: #cbf5d8;
  color: rgba(0, 150, 78, 1);
  font-size: 0.9rem;
  padding: 2px 6px;
  border-radius: 24px;
  border: 1px solid green;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  margin-top: 10px;
`;

export const ButtonLabel = styled.div`
  margin-left: 5px;
`;

export const AddButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0;
  margin-top: 10px;
`;

export const ContinuetoReviewButton = styled.div`
  margin-left: auto;
`;

export const CardHolderName = styled.div`
  min-width: 15%;
  max-width: auto;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.93);
  size: 0.9rem;
  margin-left: 30px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`;

export const LastDigits = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.93);
  size: 0.9rem;
  margin-left: 10px;
`;

export const PayByInvoiceContainer = styled.div<{
  isSelected: boolean;
}>`
  padding: 15px 15px;
  border-radius: 5px;
  border: 2px solid rgba(32, 154, 214, 1);
  margin-top: 10px;
  display: flex;
  align-items: center;
  box-shadow: ${({ isSelected }) =>
    isSelected ? '0px 4px 12px rgba(0, 0, 0, 0.08)' : 'none'};
  border: ${({ isSelected }) =>
    isSelected
      ? '2px solid rgba(32, 154, 214, 1)'
      : '1px solid rgba(0, 0, 0, 0.23)'};
  cursor: pointer;
`;

export const FinancingCompany = styled.div`
  padding: 3px 10px;
  background: rgba(32, 154, 214, 1);
  color: white;
  border-radius: 5px;
  font-weight: 500;
  font-size: 0.9rem;
`;

interface PayByInvoiceTitleProps {
  error?: boolean;
}
export const PayByInvoiceTitle = styled.div<PayByInvoiceTitleProps>`
  min-width: 15%;
  max-width: auto;
  font-weight: 500;
  color: ${({ error }) => (error ? 'rgba(212, 63, 88, 1)' : '#000')};
  size: 0.9rem;
  margin-left: 10px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 0.8rem;
  }
`;

export const Notification = styled.div`
  display: flex;
  /* align-items: center; */
  margin-bottom: 20px;
`;

export const NotificationBody = styled.div`
  color: ${({ theme }) => theme.palette.grey63};
  margin-left: 3px;
  font-size: 0.9rem;
`;

export const NotificationIcon = styled.div`
  margin-right: 5px;
  min-width: 20px;
  min-height: 20px;
`;

export const SubfundingSourceContainer = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.63);
  font-size: 0.9rem;
  margin-bottom: 10px;
`;
